import { StringConstants } from "./StringConstants";

class NotificationConstants extends StringConstants {
  GENERIC_ERROR = "An error has occurred";

  //menu service
  FULL_MENU_ERROR = "An error occurred in fetching menu.";
  TIME_SLOT_ERROR = "An error occurred in fetching time slots.";
  SEARCH_ITEMS_ERROR = "An error occurred in searching items.";
  PICKUP_SESSION_ERROR = "An error occurred in creating session.";

  //Recommmeded Items
  RECOMMENDED_ITEMS_ERROR = "An error occurred in fetching recommended items.";

  CREATE_EXPRESSUSER_FAILURE = "Failed to create an express account!";
  VERIFICATION_OTP_FAIL = "Failed to verify the OTP!";
  RESENT_OTP_FAILURE = "Failed to resend the OTP!";

  APPLE_SIGNIN_ERROR = "Error in apple Sign In. Please try again.";
  GOOGLE_SIGNIN_ERROR =
    "Cloud not logged you in with Google. Please try again.";

  ENTER_NAME_ERROR = "Please enter your name";
  ENTER_CONTACT_NUMBER_ERROR = "Please enter valid contact number.";
  ENTER_NAME_AND_CONTACT_NUMBER_ERROR =
    "Please enter your name and valid contact number.";
  EMPTY_TABLE_NUM_ERROR =
    "Table number not found. Please scan the QR code again.";

  getAutoRemoveOutOfStockItemMessage = (items: string[]) => {
    if (items.length > 1) {
      return `Sorry! ${items.join(
        ", "
      )} were recently made unavailable, we have removed the items from your cart.`;
    } else {
      return `Sorry! ${items} was recently made unavailable, we have removed the item from your cart.`;
    }
  };

  REFRESH_TOKEN_FAILURE = "You are logged out. Please log in to continue.";
  stripeHOLD =
    "Your total amount is exceeding the hold amount. Please start a new tab to continue ordering.";

  PLEASE_ADD_PAYMENT_METHOD = "Please add payment method";
}

let notifiers = new NotificationConstants();
export default notifiers;
